<!--
 * @Author: linwl 1015547748@qq.com
 * @Date: 2025-03-28 12:17:11
 * @LastEditors: linwl 1015547748@qq.com
 * @LastEditTime: 2025-12-01 17:19:56
 * @FilePath: \newmall\src\layout\TabbarLayout\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <!-- <keep-alive :include="cacheViews" :max="10">
      <router-view v-if="isKeepAlivePage" />
    </keep-alive>
    <router-view v-if="!isKeepAlivePage" /> -->
    <CacheRouterView />
    <layout-tabbar :tab-list="tabbarList"></layout-tabbar>
  </div>
</template>
<script>
import tabbar from '@/router/routes/tabbarRoute.js'
import layoutTabbar from '@/components/Tabbar.vue'
import configColor from '@/config/color.config'
import { useBaseLayout } from '@/layout/BaseLayout/hooks'
import CacheRouterView from '@/components/CacheRouterView'


export default {
  name: 'Tabbar',
  components: {
    layoutTabbar,
    CacheRouterView
  },
  // setup() {
  //   return useBaseLayout()
  // },
  data() {
    return {
      active: 0,
      clientHeight: document.documentElement.clientHeight,
      showBtn: true,
      configColor
    }
  },
  computed: {
    tabbarList() {
      const list = tabbar[0].children.map(item => {
        return {
          name: item.meta.name,
          path: item.path,
          icon: item.meta.icon
        }
      })
      return list
    }
  }
}
</script>
<style lang="scss" scoped></style>
